import React, {
  useEffect,
  useState,
} from "react";

import "./memberView.css";

import {
  updateMember,
  getKanda,
  getJumuia,
} from "../../services/api";

import { toast } from "react-toastify";
import { getCurrentUser } from "../../services/auth";

export default function MemberViewModal({
  member,
  onClose,
  onUpdated,
}) {
  const user = getCurrentUser();

  const [editing, setEditing] =
    useState(false);

  const [saving, setSaving] =
    useState(false);

  const [kandaList, setKandaList] =
    useState([]);

  const [jumuiaList, setJumuiaList] =
    useState([]);

  const [form, setForm] = useState({
    ...member,
  });

  const formatDate = (value) => {
    if (!value) return "";

    try {
      return new Date(value)
        .toISOString()
        .split("T")[0];
    } catch {
      return "";
    }
  };

  useEffect(() => {
    loadKanda();
  }, []);

  useEffect(() => {
    if (form.kanda_id) {
      loadJumuia(form.kanda_id);
    }
  }, [form.kanda_id]);

  const loadKanda = async () => {
    try {
      const res = await getKanda(
        user.parokiaId
      );

      setKandaList(
        Array.isArray(res.data)
          ? res.data
          : []
      );
    } catch (err) {
      console.error(err);
    }
  };

  const loadJumuia = async (
    kandaId
  ) => {
    try {
      const res = await getJumuia(
        user.parokiaId,
        kandaId
      );

      setJumuiaList(
        Array.isArray(res.data)
          ? res.data
          : []
      );
    } catch (err) {
      console.error(err);
    }
  };

  const setField = (
    key,
    value
  ) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      await updateMember(
        member.member_id,
        {
          kandaId: form.kanda_id,
          jumuiaId:
            form.jumuia_id,

          firstName:
            form.first_name,

          middleName:
            form.middle_name,

          surname: form.surname,

          gender: form.gender,

          dateOfBirth:
            formatDate(
              form.date_of_birth
            ),

          phone: form.phone,

          backupPhone:
            form.backup_phone,

          maritalStatus:
            form.marital_status,

          residenceArea:
            form.residence_area,

          address: form.address,

          countryName:
            form.country_name,

          regionName:
            form.region_name,

          districtName:
            form.district_name,

          isStudent:
            form.is_student,

          isJumuiaLeader:
            form.is_jumuia_leader,

          eventName:
            form.event_name,

          ageGroup:
            form.age_group,

          notes: form.notes,

          status: form.status,
        }
      );

      toast.success(
        "Member updated successfully"
      );

      setEditing(false);

      onUpdated?.();
    } catch (err) {
      console.error(err);

      toast.error(
        err?.response?.data
          ?.message ||
          "Failed to update member"
      );
    } finally {
      setSaving(false);
    }
  };

  const Field = ({
    label,
    value,
    children,
  }) => (
    <div className="field">
      <span className="field-label">
        {label}
      </span>

      {children || (
        <span className="field-value">
          {value || "-"}
        </span>
      )}
    </div>
  );

  return (
    <div className="modal-overlay member-modal-overlay">
      <div className="modal enterprise-modal member-modal">
        <div className="modal-header">
          <h3>
            Member Details
          </h3>

          <button
            className="modal-close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="modal-body">
          {/* =========================================
              PERSONAL INFO
          ========================================= */}
          <section className="section-card">
            <h4>
              Personal Information
            </h4>

            <div className="grid">
              <Field
                label="Member Code"
                value={
                  form.member_code
                }
              />

              <Field label="Full Name">
                <span className="field-value">
                  {`${form.first_name || ""} ${
                    form.middle_name || ""
                  } ${
                    form.surname || ""
                  }`}
                </span>
              </Field>

              <Field label="First Name">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.first_name ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "first_name",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {
                      form.first_name
                    }
                  </span>
                )}
              </Field>

              <Field label="Middle Name">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.middle_name ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "middle_name",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {
                      form.middle_name
                    }
                  </span>
                )}
              </Field>

              <Field label="Surname">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.surname ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "surname",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {form.surname}
                  </span>
                )}
              </Field>

              <Field label="Gender">
                {editing ? (
                  <select
                    className="input"
                    value={
                      form.gender ||
                      "MALE"
                    }
                    onChange={(e) =>
                      setField(
                        "gender",
                        e.target.value
                      )
                    }
                  >
                    <option value="MALE">
                      Male
                    </option>

                    <option value="FEMALE">
                      Female
                    </option>
                  </select>
                ) : (
                  <span className="field-value">
                    {form.gender}
                  </span>
                )}
              </Field>

              <Field label="Date of Birth">
                {editing ? (
                  <input
                    type="date"
                    className="input"
                    value={formatDate(
                      form.date_of_birth
                    )}
                    onChange={(e) =>
                      setField(
                        "date_of_birth",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {formatDate(
                      form.date_of_birth
                    )}
                  </span>
                )}
              </Field>

              <Field label="Phone">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.phone ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "phone",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {form.phone}
                  </span>
                )}
              </Field>

              <Field label="Backup Phone">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.backup_phone ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "backup_phone",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {
                      form.backup_phone
                    }
                  </span>
                )}
              </Field>

              <Field label="Marital Status">
                {editing ? (
                  <select
                    className="input"
                    value={
                      form.marital_status ||
                      "SINGLE"
                    }
                    onChange={(e) =>
                      setField(
                        "marital_status",
                        e.target.value
                      )
                    }
                  >
                    <option value="SINGLE">
                      SINGLE
                    </option>

                    <option value="MARRIED">
                      MARRIED
                    </option>

                    <option value="DIVORCED">
                      DIVORCED
                    </option>

                    <option value="WIDOWED">
                      WIDOWED
                    </option>
                  </select>
                ) : (
                  <span className="field-value">
                    {
                      form.marital_status
                    }
                  </span>
                )}
              </Field>

              <Field label="Residence Area">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.residence_area ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "residence_area",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {
                      form.residence_area
                    }
                  </span>
                )}
              </Field>

              <Field label="Address">
                {editing ? (
                  <textarea
                    className="input"
                    value={
                      form.address ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "address",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {form.address}
                  </span>
                )}
              </Field>

              <Field label="Country">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.country_name ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "country_name",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {
                      form.country_name
                    }
                  </span>
                )}
              </Field>

              <Field label="Region">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.region_name ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "region_name",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {
                      form.region_name
                    }
                  </span>
                )}
              </Field>

              <Field label="District">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.district_name ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "district_name",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {
                      form.district_name
                    }
                  </span>
                )}
              </Field>
            </div>
          </section>

          {/* =========================================
              CHURCH
          ========================================= */}
          <section className="section-card">
            <h4>
              Church Categorization
            </h4>

            <div className="grid">
              <Field
                label="Parokia"
                value={
                  form.parokia_name
                }
              />

              <Field label="Kanda">
                {editing ? (
                  <select
                    className="input"
                    value={
                      form.kanda_id ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "kanda_id",
                        e.target.value
                      )
                    }
                  >
                    <option value="">
                      Select Kanda
                    </option>

                    {kandaList.map(
                      (k) => (
                        <option
                          key={
                            k.kanda_id
                          }
                          value={
                            k.kanda_id
                          }
                        >
                          {
                            k.kanda_name
                          }
                        </option>
                      )
                    )}
                  </select>
                ) : (
                  <span className="field-value">
                    {
                      form.kanda_name
                    }
                  </span>
                )}
              </Field>

              <Field label="Jumuiya">
                {editing ? (
                  <select
                    className="input"
                    value={
                      form.jumuia_id ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "jumuia_id",
                        e.target.value
                      )
                    }
                  >
                    <option value="">
                      Select Jumuiya
                    </option>

                    {jumuiaList.map(
                      (j) => (
                        <option
                          key={
                            j.jumuia_id
                          }
                          value={
                            j.jumuia_id
                          }
                        >
                          {
                            j.jumuia_name
                          }
                        </option>
                      )
                    )}
                  </select>
                ) : (
                  <span className="field-value">
                    {
                      form.jumuia_name
                    }
                  </span>
                )}
              </Field>

              <Field
                label="Leader Name"
                value={
                  form.jumuia_leader
                }
              />

              <Field label="Is Student">
                {editing ? (
                  <select
                    className="input"
                    value={
                      form.is_student
                        ? "YES"
                        : "NO"
                    }
                    onChange={(e) =>
                      setField(
                        "is_student",
                        e.target
                          .value ===
                          "YES"
                      )
                    }
                  >
                    <option value="YES">
                      Yes
                    </option>

                    <option value="NO">
                      No
                    </option>
                  </select>
                ) : (
                  <span className="field-value">
                    {form.is_student
                      ? "Yes"
                      : "No"}
                  </span>
                )}
              </Field>

              <Field label="Is Leader">
                {editing ? (
                  <select
                    className="input"
                    value={
                      form.is_jumuia_leader
                        ? "YES"
                        : "NO"
                    }
                    onChange={(e) =>
                      setField(
                        "is_jumuia_leader",
                        e.target
                          .value ===
                          "YES"
                      )
                    }
                  >
                    <option value="YES">
                      Yes
                    </option>

                    <option value="NO">
                      No
                    </option>
                  </select>
                ) : (
                  <span className="field-value">
                    {form.is_jumuia_leader
                      ? "Yes"
                      : "No"}
                  </span>
                )}
              </Field>

              <Field label="Age Group">
                {editing ? (
                  <input
                    className="input"
                    value={
                      form.age_group ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "age_group",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {
                      form.age_group
                    }
                  </span>
                )}
              </Field>
            </div>
          </section>

          {/* =========================================
              STATUS
          ========================================= */}
          <section className="section-card">
            <h4>
              Status & Audit
            </h4>

            <div className="grid">
              <Field label="Status">
                {editing ? (
                  <select
                    className="input"
                    value={
                      form.status ||
                      "ACTIVE"
                    }
                    onChange={(e) =>
                      setField(
                        "status",
                        e.target.value
                      )
                    }
                  >
                    <option value="ACTIVE">
                      ACTIVE
                    </option>

                    <option value="INACTIVE">
                      INACTIVE
                    </option>
                  </select>
                ) : (
                  <span className="field-value">
                    {form.status}
                  </span>
                )}
              </Field>

              <Field
                label="Created At"
                value={formatDate(
                  form.created_at
                )}
              />

              <Field
                label="Updated At"
                value={formatDate(
                  form.updated_at
                )}
              />

              <Field label="Notes">
                {editing ? (
                  <textarea
                    className="input"
                    value={
                      form.notes ||
                      ""
                    }
                    onChange={(e) =>
                      setField(
                        "notes",
                        e.target.value
                      )
                    }
                  />
                ) : (
                  <span className="field-value">
                    {form.notes}
                  </span>
                )}
              </Field>
            </div>
          </section>
        </div>

        <div className="modal-footer">
          {!editing ? (
            <>
              {/* <button
                className="btn warning"
                onClick={() =>
                  setEditing(true)
                }
              >
                Edit
              </button> */}

              <button
                className="btn primary"
                onClick={onClose}
              >
                Close
              </button>
            </>
          ) : (
            <>
              <button
                className="btn"
                onClick={() =>
                  setEditing(false)
                }
              >
                Cancel
              </button>

              <button
                className="btn primary"
                onClick={
                  handleSave
                }
                disabled={saving}
              >
                {saving
                  ? "Saving..."
                  : "Save Changes"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}